module.exports = __webpack_public_path__ + "media/images/email-914317b0915628fbd81832b9a583c5dd.png";